import { 
  GET_MFA_STATUS,
  LOGIN_USER,
  MULI_FACTOR_SETUP
} from "./actions";


export const getMultifactorStatus = (payload, cb, handleFlashMessage) => ({
  type: GET_MFA_STATUS,
  payload,
  cb,
  errorFun: handleFlashMessage
});

export const loginUser = (payload, handleFlashMessage, reloginState, cb) => ({
  type: LOGIN_USER,
  payload,
  reloginState,
  cb,
  errorFun: handleFlashMessage
});

export const doMultiFactorSetup = (payload, handleFlashMessage, cb) => ({
  type: MULI_FACTOR_SETUP,
  payload,
  cb,
  errorFun: handleFlashMessage
});

// export const getMultifactorStatusError = (payload, cb, handleFlashMessage) => ({
//   type: GET_MFA_STATUS_ERROR,
//   payload: payload,
//   cb: cb,
//   errorFun: handleFlashMessage
// });


// const toggleLoader = (flag,id) => {
//     let val = flag ? 'flex': 'none';
//     if(document.getElementById(id))
//         document.getElementById(id).style.display = val;
// }
